import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Play } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/button';
import { stats } from '../../data/mock';

const Hero = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <section className="relative pt-32 pb-20 px-4 overflow-hidden bg-gradient-to-b from-emerald-50/50 via-white to-white">
      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[600px] bg-gradient-to-br from-emerald-100/40 to-teal-100/40 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto relative">
        {/* Badge */}
        <div className="flex justify-center mb-8">
          <div className="flex items-center gap-2 px-4 py-2 bg-emerald-50 border border-emerald-100 rounded-full">
            <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
            <span className="text-emerald-700 text-sm font-medium">{t('landing.hero.badge')}</span>
          </div>
        </div>

        {/* Main headline */}
        <h1 className="text-center text-5xl sm:text-6xl lg:text-7xl font-bold text-gray-900 leading-tight mb-6">
          {t('landing.hero.title_line1')}
          <br />
          <span className="bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">
            {t('landing.hero.title_line2')}
          </span>
        </h1>

        {/* Subheadline */}
        <p className="text-center text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto mb-10">
          {t('landing.hero.subtitle')}
        </p>

        {/* CTA buttons */}
        <div className="flex flex-col sm:flex-row justify-center gap-4 mb-16">
          <Button
            size="lg"
            onClick={() => navigate('/register')}
            className="group text-base px-8 py-6"
          >
            {t('landing.hero.cta_primary')}
            <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
          </Button>
          <Button
            variant="outline"
            size="lg"
            className="text-base px-8 py-6"
          >
            <Play className="w-4 h-4 mr-2 fill-current" />
            {t('landing.hero.cta_secondary')}
          </Button>
        </div>

        {/* Stats */}
        <div className="flex flex-wrap justify-center gap-8 sm:gap-16">
          {stats.map((stat) => (
            <div key={stat.key} className="text-center">
              <div className="text-3xl sm:text-4xl font-bold text-gray-900">{stat.value}</div>
              <div className="text-sm text-gray-500 mt-1">{t(`landing.stats.${stat.key}`)}</div>
            </div>
          ))}
        </div>

        {/* Hero image */}
        <div className="mt-20 relative">
          <div className="absolute -inset-4 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-2xl blur-2xl opacity-20" />
          <div className="relative rounded-xl overflow-hidden border border-gray-200 shadow-2xl bg-white">
            <img
              src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1400&q=80"
              alt="AuraBase Dashboard"
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
